import { SelectMenu } from '@/components/molecules/SelectMenu';

import type { MetricMenuGroup } from './types';

import styles from './MetricMenu.module.scss';

export interface MetricMenuProps {
    value: string;
    groups: MetricMenuGroup[];
    onChange: (next: string) => void;
    /** Prefix on the trigger, which reads "Label: Metric". */
    label: string;
    disabled?: boolean;
}

/**
 * The metric the comparison charts, picked from the licensed modules' groups. A long list,
 * so the popup scrolls inside a fixed height rather than pushing the page. The current
 * metric is a highlighted row, not a radio.
 */
export function MetricMenu(props: MetricMenuProps) {
    const { value, groups, onChange, label, disabled = false } = props;

    return (
        <div className={styles.metricMenu}>
            <SelectMenu
                value={value}
                onChange={onChange}
                groups={groups.map((group) => ({
                    label: group.label,
                    options: group.options.map((option) => ({
                        value: option.value,
                        label: option.label,
                        disabled: option.disabled,
                        disabledReason: option.title,
                    })),
                }))}
                label={label}
                disabled={disabled}
                fullWidth
                offset={4}
                indicators={false}
                solid
                triggerClassName={styles.trigger}
                menuClassName={styles.popup}
            />
        </div>
    );
}

export default MetricMenu;
